/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import { useServiceContext } from '~/root'
import { useCallback } from 'react'

export function useEventBus() {
  const context = useServiceContext()

  const emit = useCallback(
    (eventName: string, data?: any) => {
      context.bus.dispatchEvent(new CustomEvent(eventName, { detail: data }))
    },
    [context.bus]
  )

  return { emit }
}
